import React from 'react';
import styled from 'styled-components';
import FormattedMessage from 'react-intl/lib/components/message';
const StyledDialogContent = styled.div `
	box-sizing: border-box;
	padding: 30px 15px;
	background: #fff;
`;
const StyledDialogContentTitle = styled.div `
	color: #555;
	font-size: 25px;
	font-weight: bold;
	text-align: center;
`;
const StyledDialogContentText = styled.div `
	padding: 30px 0;
	text-align: center;
`;
const StyledDialogContentActions = styled.div `
	display: flex;
	flex-direction: column;
	text-align: center;
`;
const DialogContent = ({ actions, }) => (React.createElement(StyledDialogContent, null,
    React.createElement(StyledDialogContentTitle, null,
        React.createElement(FormattedMessage, { id: "congratulations" })),
    React.createElement(StyledDialogContentText, null,
        React.createElement(FormattedMessage, { id: "youHaveLoyaltyPointsThatYouCanUseOnThisProduct" }),
        " ",
        React.createElement("br", null),
        React.createElement(FormattedMessage, { id: "chooseHowYouWantToPayForIt" })),
    actions && (React.createElement(StyledDialogContentActions, null, actions))));
export default DialogContent;
